import {
  Component,
  effect,
  ElementRef,
  input,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';
import { ButtonModule } from 'primeng/button';
import { TenderFormEvaluationStrengthWeakness } from '../../../../../api/interfaces';

@Component({
  selector: 'lib-result-areas-card',
  standalone: true,
  imports: [ButtonModule, CardComponent],
  templateUrl: './areas-card.component.html',
})
export class ResultAreasCardComponent {
  strengthAreas = input<TenderFormEvaluationStrengthWeakness[]>([]);
  improvementAreas = input<TenderFormEvaluationStrengthWeakness[]>([]);

  strengthScroll = viewChild<ElementRef<HTMLDivElement>>('strengthScroll');
  improvementScroll = viewChild<ElementRef<HTMLDivElement>>('improvementScroll');

  strengthDivIsAtStart = signal(true);
  strengthDivIsAtEnd = signal(false);
  improvementDivIsAtStart = signal(true);
  improvementDivIsAtEnd = signal(false);

  scroll(direction: 'left' | 'right', type: 'strength' | 'improvement'): void {
    const container =
      type === 'strength'
        ? this.strengthScroll()?.nativeElement
        : this.improvementScroll()?.nativeElement;

    if (container) {
      container.scrollBy({
        left: direction === 'left' ? -340 : 340,
        behavior: 'smooth',
      });
    }
  }

  constructor() {
    effect(() => {
      const strengthDiv = this.strengthScroll();
      if (!strengthDiv) return;
      const areas = this.strengthAreas();
      if (areas.length === 0) {
        this.strengthDivIsAtStart.set(true);
        this.strengthDivIsAtEnd.set(true);
        return;
      }
      this.updateContentScroll(strengthDiv, this.strengthDivIsAtStart, this.strengthDivIsAtEnd);
    });

    effect(() => {
      const improvementDiv = this.improvementScroll();
      if (!improvementDiv) return;
      const areas = this.improvementAreas();
      if (areas.length === 0) {
        this.improvementDivIsAtStart.set(true);
        this.improvementDivIsAtEnd.set(true);
        return;
      }
      this.updateContentScroll(improvementDiv, this.improvementDivIsAtStart, this.improvementDivIsAtEnd);
    });
  }

  private updateContentScroll(
    content: ElementRef<HTMLDivElement>,
    startSignal: WritableSignal<boolean>,
    endSignal: WritableSignal<boolean>,
  ) {
    const update = () => {
      const el = content.nativeElement;
      startSignal.set(el.scrollLeft === 0);
      endSignal.set(el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
    };

    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(update);
    } else {
      setTimeout(update, 0);
    }

    content.nativeElement.onscroll = update;
  }
}
